import { Box, Button, Flex, Text } from "@chakra-ui/react";
import AddIcon from "@material-ui/icons/Add";
import Axios from "axios";
import FileDownload from "js-file-download";
import React from "react";
import { useHistory } from "react-router-dom";
import { api } from "../config";
import { useProductsCsvWhereState } from "../components/Product/ViewProducts/ViewProducts";
import StatusFilters from "../components/Product/ViewProducts/StatusFilters";
import ViewProducts from "../components/Product/ViewProducts/ViewProducts";

interface Props {}

const ProductsPage: React.FC<Props> = (props: any) => {
  const history = useHistory();
  const [productsCsvWhere] = useProductsCsvWhereState<any>({});
  const [downloadingCsv, setDownloadingCsv] = React.useState(false);
  const [downloadingPdf, setDownloadingPdf] = React.useState(false);

  const handleDownloadCsv = async () => {
    setDownloadingCsv(true);
    try {
      const res = await Axios.get(
        `${api}/color-cats/download-csv?where=${encodeURIComponent(
          JSON.stringify(productsCsvWhere || {}),
        )}`,
        {
          responseType: "blob",
          withCredentials: true,
        },
      );
      FileDownload(res.data, "products.csv");
    } finally {
      setDownloadingCsv(false);
    }
  };

  const handleDownloadPdf = async () => {
    setDownloadingPdf(true);
    try {
      const res = await Axios.get(
        `${api}/color-cats/download-pdf?where=${encodeURIComponent(
          JSON.stringify(productsCsvWhere || {}),
        )}`,
        {
          responseType: "blob",
          withCredentials: true,
        },
      );
      FileDownload(res.data, "products.pdf");
    } finally {
      setDownloadingPdf(false);
    }
  };

  return (
    <>
      <Flex justifyContent="space-between" alignItems="center" flexWrap="wrap">
        <Button
          colorScheme="blue"
          onClick={() => history.push("/admin/product-form")}
          className="add-btn"
          m="3"
          size="sm"
          leftIcon={<AddIcon />}
          textTransform="uppercase"
        >
          Add Product
        </Button>
        <Box textAlign="right" m="3">
          <Box>
            <Button
              colorScheme="green"
              onClick={handleDownloadCsv}
              isLoading={downloadingCsv}
              className="add-btn"
              size="sm"
              ml="3"
              textTransform="uppercase"
            >
              Download CSV
            </Button>
            <Button
              colorScheme="orange"
              onClick={handleDownloadPdf}
              isLoading={downloadingPdf}
              className="add-btn"
              size="sm"
              ml="3"
              textTransform="uppercase"
            >
              Download PDF
            </Button>
          </Box>
          <Text fontSize="sm" color="gray.500" mt="2">
            Exports all products matching the current filters, across every
            page (not just the page currently shown).
          </Text>
        </Box>
      </Flex>
      {/* <Button
        colorScheme="green"
        onClick={() => history.push("/admin/product-upload")}
        className="add-btn"
        m="3"
        size="sm"
        leftIcon={<AddIcon />}
        textTransform="uppercase"
      >
        Products bulk upload
      </Button> */}
      <StatusFilters />
      <ViewProducts />
    </>
  );
};

export default ProductsPage;
